export default __webpack_public_path__ + "static/TheSentence-poster-ce698ada6f0d78aed9b08156ae7f2483.jpg";